module.exports = __webpack_public_path__ + "static/4102-9c77b900c908c125bf1b0831cd1d0210.png";